import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { Link, Outlet } from 'react-router-dom';

function UserManagement() {
    // State to track the active tab
    const [activeTab, setActiveTab] = useState('admin');

    return (
        <>
            <Helmet>
                <title>User Management | 3pl Site</title>
            </Helmet>
            <div className="userManagement">
                <h1>USER MANAGEMENT LIST</h1>
                <div className="userCategoryList">
                    <ul className="nav nav-tabs">
                        <li className="nav-item">
                            <Link
                                className={`nav-link ${activeTab === 'admin' ? 'active' : ''}`}
                                to="admin"
                                onClick={() => setActiveTab('admin')}
                            >
                                Admin
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`}
                                to="clients"
                                onClick={() => setActiveTab('clients')}
                            >
                                Clients
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className={`nav-link ${activeTab === 'users' ? 'active' : ''}`}
                                to="users"
                                onClick={() => setActiveTab('users')}
                            >
                                Users
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link
                                className={`nav-link ${activeTab === 'marketers' ? 'active' : ''}`}
                                to="marketers"
                                onClick={() => setActiveTab('marketers')}
                            >
                                Marketers
                            </Link>
                        </li>
                    </ul>
                    <Outlet />
                </div>
            </div>
        </>
    );
}

export default UserManagement;
